<template>
    <div class="Background">
        <div class="link_location">
            <h2 class="Title">
                {{ $store.getters.t('통계') }}
                <v-icon class="mdi mdi-chevron-right" />
                <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('WebRTC LIVE 통계') }}</span>
              </h2>
        </div>
        <WebRTCStatistics />
    </div>
</template>

<script>
import WebRTCStatistics from '@/components/statistics/webrtcstatistics/WebRTCStatistics.vue';

export default {
    components: {
        WebRTCStatistics,
    },
    data() {
        return {

        };
    }
}
</script>

<style lang="scss" scoped>

</style>
